// extracted by mini-css-extract-plugin
export var displayNone = "_rq-6";
export var imgContainer = "_rq-2";
export var overflowHidden = "_rq-3";
export var productInfoCardButtonContainer = "_rq-5";
export var productTitleText = "_rq-4";
export var rightArrow = "_rq-1";
export var rightArrowContainer = "_rq-0";